// extracted by mini-css-extract-plugin
export default {"topFooterContainer":"topFooter_topFooterContainer__nK+vv","subContainer":"topFooter_subContainer__eClx5","header":"topFooter_header__Z-dXC"};